import { Controller } from '@hotwired/stimulus';

export default class AnswerController extends Controller {
  static targets = [
    'answerTextField'
  ];

  ready(e) {
    this.answerTextFieldTarget.value = e.detail.answer;

    this.#dispatchChangedAnswer();
  }

  notReady() {
    this.answerTextFieldTarget.value = '';

    this.#dispatchChangedAnswer();
  }

  #dispatchChangedAnswer() {
    this.dispatch('changedAnswer');
  }
}
